export const statusFlags = [
  { key: 'minimum_documents', value: 'Mindestunterlagen vorhanden (3 Gehaltsabrechnungen + Objektinfo)' },
  { key: 'data_collection', value: 'Kundendaten erfassen' },
  { key: 'consultation_offer', value: 'Beratung + Angebot' },
  { key: 'full_documents_requested', value: 'Komplette Unterlagen anfordern (Bonität + Objekt)' },
  { key: 'documents_complete', value: 'Unterlagen vollständig' },
  { key: 'quality_check', value: 'QualityCheck + Abgleich Europace' },
  { key: 'self_disclosure', value: 'Selbstauskunft + ggf. KfW Formulare unterschreiben lassen' },
  { key: 'application_submission_info', value: 'Antragseinreichung + Kundeninfo' },
  { key: 'bank_feedback_info', value: 'Rückmeldung Bank ist da > Kundeninfo' },
  { key: 'feedback', value: 'Feedback (Telefonisch + Email)' },
]
